import { ReactTagManager } from 'react-gtm-ts';

export type LoadGoogleTagManagerServiceProps = {
  apiKey: string;
};

export async function LoadGoogleTagManagerService({
  apiKey,
}: LoadGoogleTagManagerServiceProps) {
  if (!apiKey) {
    console.warn(
      '⚠️ Warning: skipping loading google tag manager: no api key provided'
    );
    return;
  }

  await ReactTagManager.init({
    code: apiKey,
  });
}
